'use client'

import React, { useState } from 'react'
import { ChevronDown, Globe } from 'lucide-react'
import { Language } from '../utils/dictionary'
import { IconUSA, IconBrazil, IconSpain } from '../assets/icons/icons'

interface LanguageSwitcherProps {
  currentLanguage: Language
  languages: Language[]
  onChangeLanguage: (lang: Language) => void
}

/**
 * Banderas disponibles
 */
const FLAGS: Partial<Record<Language, React.ComponentType<any> | null>> = {
  [Language.ENGLISH]: IconUSA,
  [Language.SPANISH]: IconSpain,
  [Language.PORTUGUESE]: IconBrazil,
}

const DEFAULT_FLAG = <Globe size={16} />

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  currentLanguage,
  languages,
  onChangeLanguage,
}) => {
  const [open, setOpen] = useState(false)

  const CurrentFlag = FLAGS[currentLanguage]

  return (
    <div className="relative inline-block">
      {/* Selected */}
      <button
        onClick={() => setOpen((v) => !v)}
        className="
          flex items-center gap-2 px-3 py-2 rounded-md
          bg-gray-100 hover:bg-gray-200
          text-sm font-medium text-gray-700
          transition
        "
      >
        <span className="text-base">
          {CurrentFlag && <CurrentFlag width="20" height="20" className="sm:w-6 sm:h-6 flex-shrink-0" /> || DEFAULT_FLAG}
        </span>

        <span className="uppercase">{currentLanguage}</span>

        <ChevronDown
          size={16}
          className={`transition-transform ${open ? 'rotate-180' : ''}`}
        />
      </button>

      {/* Options */}
      {open && (
        <div
          className="
            absolute right-0 mt-2 min-w-full
            bg-white border border-gray-200 rounded-md shadow-lg
            z-50
          "
        >
          {languages.map((lang) => {
            const Flag = FLAGS[lang]

            return (
              <button
                key={lang}
                onClick={() => {
                  onChangeLanguage(lang)
                  setOpen(false)
                }}
                className={`
                  flex items-center gap-2 w-full px-3 py-2 text-sm
                  hover:bg-gray-100 transition
                  ${
                    lang === currentLanguage
                      ? 'bg-gray-100 font-medium'
                      : 'text-gray-700'
                  }
                `}
              >
                <span className="text-base">
                  {Flag ? <Flag width="20" height="20" className="sm:w-6 sm:h-6 flex-shrink-0" /> : DEFAULT_FLAG}
                </span>
                <span className="uppercase">{lang}</span>
              </button>
            )
          })}
        </div>
      )}
    </div>
  )
}
